import { type CSSProperties } from 'typestyle/lib/types';
import { type SxProps } from '@mui/material';
import StyleConstants from '../../../core/styles.constants';

export const filterContainer = (
  isMobile: boolean,
): CSSProperties => ({
  display: 'flex',
  flexDirection: isMobile ? 'column' : 'row',
  gap: 12,
  marginBottom: 16,
});

export const searchFieldSx = (
  isMobile: boolean,
): SxProps => ({
  flex: isMobile ? undefined : 1,
  width: isMobile ? '100%' : undefined,
  '& .MuiOutlinedInput-root': {
    borderRadius: '8px',
    fontSize: StyleConstants.CARD_BODY_FONT_SIZE,
    fontFamily: StyleConstants.PRIMARY_FONT_FAMILY,
  },
});

export const searchIconSx: SxProps = {
  color: StyleConstants.LIGHT_GREY_COLOR,
  fontSize: 20,
};
